import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectWidgetListDimensionsDomain = (state) =>
  state.get("widgetListDimensionsV2", initialState)

export const makeSelectIsLoading = () =>
  createSelector(selectWidgetListDimensionsDomain, (state) =>
    state.get("isLoading")
  )

export const makeSelectDimensionsTop = () =>
  createSelector(selectWidgetListDimensionsDomain, (state) =>
    state.get("dimensionsTop")
  )

export const makeSelectDimensionsBottom = () =>
  createSelector(selectWidgetListDimensionsDomain, (state) =>
    state.get("dimensionsBottom")
  )

export const makeSelectDimensionsTopBenchmark = () =>
  createSelector(selectWidgetListDimensionsDomain, (state) =>
    state.get("dimensionsTopBenchmark")
  )

export const makeSelectDimensionsBottomBenchmark = () =>
  createSelector(selectWidgetListDimensionsDomain, (state) =>
    state.get("dimensionsBottomBenchmark")
  )

const makeSelectWidgetListDimensions = () =>
  createSelector(selectWidgetListDimensionsDomain, (substate) => substate.toJS())

export default makeSelectWidgetListDimensions
export { selectWidgetListDimensionsDomain }
